import { ICellRendererParams } from "@ag-grid-community/core";
import { Text } from "@chakra-ui/react";
import React from "react";
import { FundFamilyUseAllocationTableContext } from "shared/components/fund-family-use-allocation/FundFamilyUseAllocationTableProps";

export const FundFamilyUseAllocationTableTotalHeaderRenderer: React.FC<
  ICellRendererParams
> = (params) => (
  <Text fontWeight="medium">
    {
      (params.context as FundFamilyUseAllocationTableContext).tableDef
        .total_title
    }
  </Text>
);
